module.exports = __webpack_public_path__ + "img/info.44202296.svg";